import { NCWalletTabs, useIntl, useSettings } from '@capsicum/common';
import { type ItemTabProps, useRouter, useSearchParam } from '@capsicum/common-web';
import { isNCWalletTabs } from '@capsicum/features/nc-wallet/shared';
import { useCallback, useMemo } from 'react';

import { NCWalletNftsTab } from '../../feature/nc-wallet-nfts-tab/NCWalletNftsTab';
import { NCWalletTokensTab } from '../../feature/nc-wallet-tokens-tab/NCWalletTokensTab';

export const useNCWalletTabs = () => {
	const { $t } = useIntl();
	const { settings } = useSettings();
	const { isNCWalletNFTsEnabled, isPoblanoEnabled } = settings || {};

	const tabParam = useSearchParam('tab');
	const activeTab: NCWalletTabs =
		isNCWalletTabs(tabParam) && isPoblanoEnabled && isNCWalletNFTsEnabled ? tabParam : NCWalletTabs.NCTokens;

	const { shallowReplaceSearchParam } = useRouter();
	const setActiveTab = useCallback(
		(name: string) => {
			shallowReplaceSearchParam('tab', name);
		},
		[shallowReplaceSearchParam]
	);

	const tabs: Array<ItemTabProps> = useMemo(
		() => [
			{
				component: NCWalletTokensTab,
				hasActivityIndicator: false,
				id: NCWalletTabs.NCTokens,
				tabTestId: 'ncWallet-tabBar-tokens',
				text: $t('ncWallet.home.tokens')
			},
			...(isPoblanoEnabled && isNCWalletNFTsEnabled
				? [
						{
							component: NCWalletNftsTab,
							hasActivityIndicator: false,
							id: NCWalletTabs.NCNfts,
							tabTestId: 'ncWallet-tabBar-nfts',
							text: $t('ncWallet.home.NFTs')
						}
					]
				: [])
		],
		[$t]
	);

	return {
		activeTab,
		setActiveTab,
		tabs
	};
};
